module.exports = __webpack_public_path__ + "img/icon_manejo_de_referidos_seguimiento.2184215b.svg";